<div class="vstack gap-3 align-items-start p-4">
    @if (description) {
        <span
            class="text-body-secondary"
            style="white-space: pre-line;"
            [innerHTML]="description"
        >
        </span>
    }
    @if (imageId) {
        <img
            class="img-fluid rounded"
            [ngSrc]="environment.cdnUrl | thumbor : imagePath + imageId : { width: width, height: height, aspectFit: aspectFit }"
            [width]="width"
            [height]="height"
            [alt]="alt"
        />
        <button
            class="btn btn-outline-danger"
            type="button"
            [disabled]="disabled"
            (click)="onRemove()"
        >
            Remove
        </button>
    } @else if (uploading) {
        <div
            class="btn btn-outline-dashed w-100 py-4 vstack gap-2 justify-content-center align-items-center"
            role="status"
            aria-live="polite"
        >
            <span
                class="spinner-border text-body"
                aria-hidden="true"
            ></span>
            <span>Uploading...</span>
        </div>
    } @else {
        <button
            class="btn btn-outline-dashed w-100"
            type="button"
        >
            <label
                class="m-0 form-label py-4 vstack gap-2 justify-content-center align-items-center"
                [for]="inputId"
            >
                <span class="bi bi-image fs-1 text-body-secondary"></span>
                <span>Upload Image</span>
            </label>
            <input
                [id]="inputId"
                accept="image/*"
                class="form-control d-none"
                type="file"
                [disabled]="disabled"
                (change)="onFileSelected($event)"
            />
        </button>
    }
    @if (validationError) {
        <div
            class="invalid-feedback d-block"
            role="alert"
        >
            {{ validationError }}
        </div>
    }
</div>
